import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSFX } from 'js/hooks/useSFX';

// import icons
import IconInfo from 'js/components/icon/Icon.info';
import IconCross from 'js/components/icon/Icon.cross';
import IconShapes from 'js/components/icon/Icon.shapes';

const infoVariants = {
  hidden: {
    opacity: 0,
    scale: 0.2,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 260,
      damping: 20,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.2,
    transition: {
      duration: 0.2,
      ease: 'easeInOut',
      delay: 0.4,
    },
  },
};

const HeaderInfo = ({ title = '', infoText = '' }) => {
  const [showInfo, setShowInfo] = useState(false);
  const { playSFX } = useSFX();

  return (
    <header className={'header--info' + (showInfo ? ' header--info--active' : '')} style={{ position: 'relative' }}>
      <IconShapes className="icon-shapes" />

      <AnimatePresence>
        {showInfo && (
          <>
            <motion.section
              key="info"
              variants={infoVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              style={{
                position: 'absolute',
                top: '-10px',
                left: '-10px',
                width: 'calc(100% + 20px)',
                height: 'fit-content',
                background: '#fff',
                padding: '90px 30px 30px',
                transformOrigin: 'top left',
                zIndex: 10,
                borderRadius: '40px',
              }}
            >
              <motion.span
                className="info-text"
                key="info-text"
                animate={{ opacity: 1, transition: { delay: 0.4 } }}
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
              >
                {infoText}
              </motion.span>
            </motion.section>
            <motion.button
              onClick={() => {
                playSFX('button_tap');
                setShowInfo(false);
              }}
              key="info-cross"
              className="info-cross"
              animate={{ opacity: 1, transition: { delay: 0.4 } }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              style={{ position: 'absolute', right: 20, zIndex: 11 }}
            >
              <IconCross />
            </motion.button>
          </>
        )}
      </AnimatePresence>

      <IconInfo
        onClick={() => {
          playSFX('button_tap');
          setShowInfo((v) => !v);
        }}
        className="info-icon"
        style={{
          position: 'relative',
          zIndex: 11,
          width: '28px',
          height: '28px',
          cursor: 'pointer',
        }}
      />

      <h1 style={{ position: 'relative', zIndex: 11 }}>{title}</h1>
    </header>
  );
};

export default HeaderInfo;
